import { Layers, Video, MessageCircle, PhoneCall, Check } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { CtaButton } from "./CtaButton";

const APP_INCLUDES = [
  "Oltre 30 ore di formazione",
  "Approfondimenti biblici",
  "Sfida Deserto",
  "Routine",
  "Allenamenti",
  "Ricette",
  "Diario",
  "Versetti e riflessioni",
  "Social interno",
  "Pubblicazione di post e immagini",
  "Chat e gruppi tematici",
];

const MEETING_TOPICS = [
  "Identità cristiana",
  "Fede e vita quotidiana",
  "Disciplina",
  "Emozioni",
  "Relazioni",
  "Matrimonio",
  "Famiglia",
  "Paure",
  "Abitudini",
  "Lavoro",
  "Chiamata e scopo",
];

const BLOCKS = [
  {
    icon: Layers,
    title: "Tutto il piano App",
    body: (
      <ul className="mt-4 grid gap-2 sm:grid-cols-2">
        {APP_INCLUDES.map((item) => (
          <li
            key={item}
            className="flex items-start gap-2 text-sm text-[#B8B8B8]"
          >
            <Check
              className="mt-0.5 h-4 w-4 shrink-0 text-[#C9A45C]"
              aria-hidden="true"
            />
            {item}
          </li>
        ))}
      </ul>
    ),
  },
  {
    icon: Video,
    title: "Incontri settimanali di Community Coaching",
    body: (
      <>
        <p className="mt-4 text-sm leading-relaxed text-[#B8B8B8]">
          Incontri online di gruppo con formazione, ascolto, domande e
          confronto, dedicati a:
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {MEETING_TOPICS.map((topic) => (
            <span
              key={topic}
              className="rounded-sm border border-[#C9A45C]/30 px-3 py-1 text-xs uppercase tracking-wider text-[#E8D5A3]"
            >
              {topic}
            </span>
          ))}
        </div>
      </>
    ),
  },
  {
    icon: MessageCircle,
    title: "Gruppo WhatsApp privato",
    body: (
      <p className="mt-4 text-sm leading-relaxed text-[#B8B8B8]">
        Accesso al gruppo WhatsApp riservato ai membri della Community Coaching
        di Fede &amp; Fitness Italia. Uno spazio più diretto rispetto alle chat
        interne dell'app.
      </p>
    ),
  },
  {
    icon: PhoneCall,
    title: "Contatto diretto con Elio e Chiara",
    body: (
      <>
        <p className="mt-4 text-sm leading-relaxed text-[#B8B8B8]">
          Possibilità di contattare Elio Briotti e Chiara Perrone tramite
          WhatsApp durante la quotidianità, per domande, chiarimenti, dubbi sul
          percorso, confronti sui temi trattati e indicazioni sulla crescita
          personale e spirituale.
        </p>
        <p className="mt-3 text-xs leading-relaxed text-[#8F7138]">
          Le risposte avvengono compatibilmente con gli impegni dei fondatori.
          Il servizio non equivale a coaching individuale illimitato o
          assistenza continua 24 ore su 24.
        </p>
      </>
    ),
  },
];

export const CommunityPlanSection = () => (
  <section id="community" className="bg-[#080808] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <SectionHeading
        eyebrow="Tempio Vivo Community Coaching — 49 €/mese"
        title="Non soltanto contenuti. Anche accompagnamento e confronto diretto."
        subtitle="Il piano Community Coaching comprende tutto ciò che trovi nell'App Tempio Vivo e aggiunge un livello di accompagnamento più personale: incontri di gruppo, confronto con altri cristiani e un contatto più diretto con i fondatori."
        testid="community-plan-heading"
      />
      <div className="grid gap-5 md:grid-cols-2">
        {BLOCKS.map((block, i) => (
          <Reveal key={block.title} delay={0.08 * i}>
            <div
              data-testid={`community-block-${i + 1}`}
              className="h-full rounded-sm border border-[#C9A45C]/30 bg-[#121212] p-8 transition-all duration-300 hover:-translate-y-1 hover:border-[#C9A45C]/60 hover:shadow-[0_4px_30px_rgba(201,164,92,0.15)]"
            >
              <block.icon
                className="h-7 w-7 text-[#C9A45C]"
                aria-hidden="true"
                strokeWidth={1.5}
              />
              <h3 className="font-display mt-4 text-xl font-semibold text-white">
                {block.title}
              </h3>
              {block.body}
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 text-center">
        <p className="font-display text-2xl font-semibold uppercase text-white sm:text-3xl">
          Dalla crescita digitale a un percorso{" "}
          <span className="text-[#C9A45C]">con un confronto più diretto</span>.
        </p>
        <p
          data-testid="community-plan-price"
          className="font-display mt-8 text-5xl font-semibold text-white"
        >
          49&nbsp;€
          <span className="ml-2 align-middle text-base uppercase tracking-widest text-[#B8B8B8]">
            /mese
          </span>
        </p>
        <div className="mt-8">
          <CtaButton
            plan="community"
            testid="community-plan-cta-button"
            showArrow
            className="w-full sm:w-auto"
          >
            Entra nella Community Coaching
          </CtaButton>
        </div>
        <p className="mt-4 text-xs uppercase tracking-widest text-[#8F7138]">
          App completa + incontri settimanali + WhatsApp privato + contatto con
          Elio e Chiara.
        </p>
      </Reveal>
    </div>
  </section>
);
